<template>
    <div :class="errors ? 'el-form-item is-error' : 'el-form-item'">        
        <label>{{label}}</label>
        <br>
        <el-select v-model="innerValue" :disabled="disabled" :placeholder="$t('selectInputPlaceholder')" :multiple="isMultiple">
            <el-option
                v-for="(index,d) in data" :key="index"
                :label="useLocale ? d[optionLabel][locale] : $t(d[optionLabel])"
                :value="d[optionValue]">
            </el-option>
        </el-select>

        <small v-if="errors" class="error-msg"> {{ errors }} </small>
    </div>
</template>

<script>
    import { bus } from "../../Bus"
    import { mapGetters } from 'vuex'

    export default {
        name: 'SelectField',
        props: {
            value: {
                isRequired: false
            },
            label: {
                isRequired: true
            },
            placeholder: {
                default: 'Select'
            },
            data: {
                type: Array,
                isRequired: true
            },
            optionLabel: {
                type: String,
                default: 'name'
            },
            optionValue: {
                type: String,
                default: 'id'
            },
            errors: {
                type: String
            },
            isMultiple: {
                type: Boolean
            },
            disabled: {
                isRequired: false
            }
        },
        watch: {
            value(val) {
                this.innerValue = val
            },
            innerValue(val) {
                this.$emit('input', val)
            }
        },
        data() {
            return {
                innerValue: this.value,
                useLocale: false
            }
        },
        computed: {
            ...mapGetters({
                locale: 'getLocale'
            })
        },
        created () {            
            bus.$on('clearSelectInput', () => {
                this.innerValue = '';
            })
            if (typeof this.data[0][this.optionLabel] != 'string') {
                this.useLocale = true
            }
        }
    }
</script>

<style scoped>
    .block {
        display: inline-block;
    }

    .el-select {
        margin-top: 10px;
        margin-bottom: 10px;
    }
    
    .el-form-item {
        margin: 10 !important;
        display: block;
    }

    .el-form-item.is-error .el-select {
        margin-bottom: 0;
    }

    .error-msg {
        color: red;
        margin-bottom: 5px;
        display: block;
        margin-top: 3px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Inputs/SelectField.vue